import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import Modal from "react-modal";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    border: "8px solid #9ba5ad",
    maxHeight: "100vh",
    overflowY: "auto",
  },
};

const ViewUserDetails = (props) => {
  const dispatch = useDispatch();
  // const clearUserDetails = () =>
  //   dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });

  useEffect(() => {
    return () => {
      dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
    };
  }, [dispatch]);

  const { userDetails } = props;
  const {
    preferred_username: uid,
    email,
    given_name,
    family_name,
    "custom:Groups": accessrole,
  } = userDetails;
  return (
    <>
      <Modal
        isOpen={props.modal}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.toggle}
      >
        <Container fluid>
          <Form>
            <h5>User Details</h5>
            <hr />
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="uid" id="uid" className="label">
                    User ID:
                  </Label>
                  <Label for="UIDVal" id="UIDVal">
                    {uid}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="email" id="email" className="label">
                    Email ID:
                  </Label>
                  <Label for="emailVal" id="emailVal">
                    {email}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="firstName" id="firstName" className="label">
                    First Name:
                  </Label>
                  <Label for="firstNameVal" id="firstNameVal">
                    {given_name}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="lastName" id="lastName" className="label">
                    Last Name:
                  </Label>
                  <Label for="lastNameVal" id="lastNameVal">
                    {family_name}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="accessrole" id="accessrole" className="label">
                    Access Role(s):
                  </Label>
                  <Input
                    style={{ backgroundColor: "#ffffff" }}
                    type="textarea"
                    // for='accessroleVal'
                    id="accessroleVal"
                    disabled
                    value={accessrole}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button
              onClick={(e) => {
                e.preventDefault();
                props.toggle();
              }}
              style={{ float: "right" }}
            >
              Cancel
            </Button>
          </Form>
        </Container>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(ViewUserDetails);
